'use client';
import { load } from 'cheerio';
import { useParams } from 'next/navigation';
import styles from './article.module.css';
import { localizeHtmlLinks } from '@/lib/utils';

const Content = ({ content }: { content: string }) => {
  const params = useParams<{ countryCode?: string }>();
  const renderRichText = (htmlContent: string) => {
    const localized = localizeHtmlLinks(htmlContent ?? '', params?.countryCode);
    const $ = load(localized);

    $('h1').each((index: any, element: any) => {
      const sectionId = `section-${index + 1}`;
      $(element).attr('id', sectionId);
      $(element).attr('class', 'blog-content-heading');
    });

    return { __html: $.html() };
  };

  return (
    <div
      id="article-content"
      className={`w-full no-scrollbar ${styles.articleSection}`}
      dangerouslySetInnerHTML={renderRichText(content)}
    />
  );
};

export default Content;
